/**
 * Proposal cost total — the ink-ruled footer beneath an option list / cost breakdown. Leads with a
 * label (e.g. "Total" or "Selected total"), a muted per-person line, and the grand amount on the
 * right. Callers pass already-formatted, localised strings (the component is presentation-only).
 * Styling: `.cost-total` (`.lbl` / `.pp` / `.amt`).
 */
export interface CostTotalProps {
  /** Left-hand label, e.g. "Total" / "Selected total". */
  label: string;
  /** The grand total, already formatted (e.g. "€11,214"). */
  amountLabel: string;
  /** Optional per-person / pax sub-line (e.g. "€623 per person · 18 pax"). */
  perPersonLabel?: string;
}

export function CostTotal({ label, amountLabel, perPersonLabel }: CostTotalProps) {
  return (
    <div className="cost-total">
      <div>
        <div className="lbl">{label}</div>
        {perPersonLabel && <div className="pp mono">{perPersonLabel}</div>}
      </div>
      <div className="amt">{amountLabel}</div>
    </div>
  );
}
